import React, { FC } from 'react';
import { Box } from '@mui/material';
import { CaseListSourceStatuses, ScanSource } from 'models/scanner-case';
import StatusIndicator from './status-indicator.component';

type ScannerSourceStatusProps = {
    status?: CaseListSourceStatuses;
};
const ScannerSourceStatus: FC<ScannerSourceStatusProps> = ({ status }: ScannerSourceStatusProps) => {
    return (
        <Box display="flex" gap={2}>
            {status?.threeShape ? (
                <Box>
                    <StatusIndicator source={ScanSource.THREE_SHAPE} status={status.threeShape} />
                </Box>
            ) : null}
            {status?.medit ? (
                <Box>
                    <StatusIndicator source={ScanSource.MEDIT} status={status.medit} />
                </Box>
            ) : null}
            {status?.dexis ? (
                <Box>
                    <StatusIndicator source={ScanSource.DEXIS} status={status.dexis} />
                </Box>
            ) : null}
            {status?.panda ? (
                <Box>
                    <StatusIndicator source={ScanSource.PANDA} status={status.panda} />
                </Box>
            ) : null}
            {status?.pandaEu ? (
                <Box>
                    <StatusIndicator source={ScanSource.PANDA_EU} status={status.pandaEu} />
                </Box>
            ) : null}
            {status?.dsCore ? (
                <Box>
                    <StatusIndicator source={ScanSource.DS_CORE} status={status.dsCore} />
                </Box>
            ) : null}
        </Box>
    );
};

export default ScannerSourceStatus;
